import {
     favicon,
     arrowPreview,
     arrowPlay,
     arrowPlayRadius,
     arrowSelect,
     arrowAccount,
     iconDelete,
     iconInfo,
     iconInfoCilcle,
     iconMaximize,
     iconMinimize,
     fileExport,
     iconEye,
     iconEyeSlash,
} from './custom';

import {
     cilApplicationsSettings,
     cilSpeedometer,
     cilSun,
     cilMoon,
     cilUser,
     cilLockLocked,
     cilAccountLogout,
     cilFace,
     cilBrowser,
     cilAssistiveListeningSystem,
     cilTags,
     cilPuzzle,
     cilRecycle,
     cibHubspot,
     cibWordpress,
     cilInbox,
     cilGroup,
     cilWalk,
     cilCloudDownload,
     cilSend,
     cilDelete,
     cilSave,
     cilCode,
     cilLayers,
     cilGraph,
     cilMediaPlay,
     cilBell,
     cilDollar,
     cilX,
     cilBuilding,
     cilMenu,
     cilList,
     cilCheckCircle,
     cibGoogle,
     cibTwitter,
     cibFacebook,
     cibInstagram,
     cibLinkedin,
     cibSlack,
     cilEnvelopeClosed,
     cilSearch,
     cilLifeRing,
     cilCalendar,
     cilBan,
     cilUserFollow,
     cilUserUnfollow,
     cilChartPie,
     cilBasket,
     cilTerminal,
     cilFork,
     cilFeaturedPlaylist,
     cilSettings,
     cilChevronDoubleDown,
     cilPeople,
     cilMemory,
     cilControl,
     cilCheck,
     cilCloudUpload,
     cilLoopCircular,
     cilChevronLeft,
     cilChevronRight,
     cilCircle,
     cilSoccer,
     cilGift,
     cilXCircle,
     cilPlus,
     cilListFilter,
     cilArrowRight,
} from '@coreui/icons';

export const icons = Object.assign(
     {},
     {
          favicon,
          arrowPreview,
          arrowPlay,
          arrowPlayRadius,
          arrowSelect,
          arrowAccount,
          iconDelete,
          iconInfo,
          iconInfoCilcle,
          iconMaximize,
          iconMinimize,
          fileExport,
          iconEye,
          iconEyeSlash,
     },
     {
          cilApplicationsSettings,
          cilSpeedometer,
          cilSun,
          cilMoon,
          cilUser,
          cilLockLocked,
          cilAccountLogout,
          cilFace,
          cilBrowser,
          cilAssistiveListeningSystem,
          cilTags,
          cilPuzzle,
          cilRecycle,
          cibHubspot,
          cibWordpress,
          cilInbox,
          cilGroup,
          cilWalk,
          cilCloudDownload,
          cilSend,
          cilDelete,
          cilSave,
          cilCode,
          cilLayers,
          cilGraph,
          cilMediaPlay,
          cilBell,
          cilDollar,
          cilX,
          cilBuilding,
          cilMenu,
          cilList,
          cilCheckCircle,
          cibGoogle,
          cibTwitter,
          cibFacebook,
          cibInstagram,
          cibLinkedin,
          cibSlack,
          cilEnvelopeClosed,
          cilSearch,
          cilLifeRing,
          cilCalendar,
          cilBan,
          cilUserFollow,
          cilUserUnfollow,
          cilChartPie,
          cilBasket,
          cilTerminal,
          cilFork,
          cilFeaturedPlaylist,
          cilSettings,
          cilChevronDoubleDown,
          cilPeople,
          cilMemory,
          cilControl,
          cilCheck,
          cilCloudUpload,
          cilLoopCircular,
          cilChevronLeft,
          cilChevronRight,
          cilCircle,
          cilSoccer,
          cilGift,
          cilXCircle,
          cilPlus,
          cilListFilter,
          cilArrowRight,
     }
);
